import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightmode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17.8 17.8",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			className: "st1",
			cx: 8.9,
			cy: 8.9,
			r: 3
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 8.3,
			y: 3.1,
			width: 1.2,
			height: 1.8,
			rx: .6,
			ry: .6
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 3.4,
			y: 8,
			width: 1.2,
			height: 1.8,
			rx: .6,
			ry: .6,
			transform: "translate(-4.9 12.9) rotate(-90)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 8.3,
			y: 12.9,
			width: 1.2,
			height: 1.8,
			rx: .6,
			ry: .6,
			transform: "translate(17.8 27.6) rotate(180)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 13.2,
			y: 8,
			width: 1.2,
			height: 1.8,
			rx: .6,
			ry: .6,
			transform: "translate(22.7 -4.9) rotate(90)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 4.9,
			y: 4.6,
			width: 1.2,
			height: 1.8,
			rx: .6,
			ry: .6,
			transform: "translate(-2.3 5.4) rotate(-45)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 4.9,
			y: 11.5,
			width: 1.2,
			height: 1.8,
			rx: .6,
			ry: .6,
			transform: "translate(.6 24.9) rotate(-135)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 11.8,
			y: 11.5,
			width: 1.2,
			height: 1.8,
			rx: .6,
			ry: .6,
			transform: "translate(29.8 12.4) rotate(135)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st1",
			x: 11.8,
			y: 4.6,
			width: 1.2,
			height: 1.8,
			rx: .6,
			ry: .6,
			transform: "translate(7.5 -7.1) rotate(45)"
		})
	]
});
export default SvgLightmode;
